<div class="landing-page row align-items-center">
    <div class="col-sm-7 ps-5">
        <p class="medium-text mb-2">Enter the order number to search for order details.</p>
            <p-inputgroup>
                <input pInputText id="landing-page-order-number" placeholder="Search here..." #searchInput/>
                <p-inputgroup-addon class="bg-primary justify-content-center">
                    <p-button icon="pi pi-search"  variant="text" (click)="searchClicked(searchInput.value)" />
                </p-inputgroup-addon>
            </p-inputgroup> 
            <div *ngIf="errorFlag" class="mt-2">
                 <i>No results found! Please <a href="javascript: void(0)" (click)="contactUs()">contact us</a> if you need assistance.</i>    
            </div>
    </div>
    <div class="col-sm-5 text-center">
        <img src="../assets/images/landing.png" class="img-fluid" alt="Landing Page Graphic" />
    </div>
</div>

<!-- add dialogs here -->
<app-modal [header]="'Need Help'" [(showDialog)]="showHelpModal" [acceptLabel]="'CLOSE'"
  (acceptModalClick)="showHelpModal = false">
  <app-need-help-modal></app-need-help-modal>
</app-modal>